// // import React, { useEffect, useState } from "react";
// // import CustomTable from "../../../Components/Table/CustomTable";

// // import { Grid } from "@mui/material";

// // import UserRoleCreateModal from "../Modal/UserRoleCreateModal";
// // import AllUserListCreateModal from "../Modal/UserListCreateModal";
// // import actions from "../../../ReduxStore/actions/index";
// // import { useDispatch, useSelector } from "react-redux";
// // import {
// //   setHeaderName,
// //   setSubHeaderName,
// // } from "../../../ReduxStore/Slices/headerSlice";

// // const UserList = () => {
// //   const dispatch = useDispatch();

// //   const { multiUserCreation } = useSelector(
// //     (state) => state?.multiUserCreation
// //   );

// //   const tableData = [
// //     {
// //       Name: "Vallarasu",
// //       Email: "valla@gmail.com",
// //       MobileNumber: "1232343444",
// //       UserRole: "Admin",
// //       Status: "Active",
// //     },
// //     {
// //       Name: "Pravin",
// //       Email: "pravin@gmail.com",
// //       MobileNumber: "98787687687",
// //       UserType: "Super Admin",
// //       Status: "Active",
// //     },
// //     {
// //       Name: "Shahul",
// //       Email: "shahul@gmail.com",
// //       MobileNumber: "123322443543",
// //       UserType: "Opeartor",
// //       Status: "Active",
// //     },
// //     {
// //       Name: "Ramesh",
// //       Email: "Ramesh@gmail.com",
// //       MobileNumber: "76575675664",
// //       UserType: "Admin",
// //       Status: "Active",
// //     },
// //     {
// //       Name: "Sanjeev",
// //       Email: "Sanjeev@gmail.com",
// //       MobileNumber: "909878789709",
// //       UserType: "Super Admin",
// //       Status: "Active",
// //     },
// //   ];
// //   const tableHeadData = [
// //     "S.No",
// //     "Name",
// //     "User ID",
// //     "Email",
// //     "Mobile Number",
// //     "User Role",
// //     "Status",
// //   ];

// //   const { getAllUserWithRole } = useSelector(
// //     (state) => state?.getAllUserWithRole
// //   );

// //   console.log(
// //     getAllUserWithRole?.data,
// //     "getAllCustomersStatusgetAllCustomersStatus"
// //   );

// //   useEffect(() => {
// //     const fetchData = async () => {
// //       const data1 = { data: {}, method: "get", apiName: `getAllAuthUser` };
// //       await dispatch(actions.GETALLUSERWITHROLE(data1));
// //     };
// //     fetchData();
// //   }, [dispatch, multiUserCreation]);




// //   const [rowTableData, setRowTableData] = useState([
// //     {
// //       name: "--",
// //       operator_id: "--",
// //       email: "--",
// //       phone: "--",
// //       userRole: "--",
// //       Status: "--",
// //     },
// //   ]);

// //   useEffect(() => {
// //     const tempArr = [];
// //     getAllUserWithRole?.data?.map((data, index) => {
// //       return tempArr.push({
// //         name: `${data?.name}`,
// //         user_id: data?.user_id,
// //         email: data?.email,
// //         phone: data?.phone,
// //         userRole: data?.userRole,
// //         Status: data?.delete_status === 0 ? "Active" : "Inactive",
// //       });
// //     });
// //     setRowTableData(tempArr);
// //   }, [dispatch, getAllUserWithRole, multiUserCreation]);










// //   React.useEffect(() => {
// //     dispatch(setHeaderName("Master"));
// //     dispatch(setSubHeaderName("User List"));
// //   }, [dispatch]);

// //   return (
// //     <Grid container spacing={2}>
// //       <Grid item xs={12} sx={{ width: "100px" }}>
// //         <CustomTable
// //           tableData={rowTableData}
// //           title="User List"
// //           tableHeadData={tableHeadData}
// //           modalName={AllUserListCreateModal}
// //           modalHeadingName="Create User"
// //           tableEdit="tableEdit"
// //           tableDelete="tableDelete"
// //         />
// //       </Grid>
// //     </Grid>
// //   );
// // };

// // export default UserList;

// import React, { useEffect, useState } from "react";
// import CustomTable from "../../../Components/Table/CustomTable";

// import { Grid } from "@mui/material";

// import UserRoleCreateModal from "../Modal/UserRoleCreateModal";
// import AllUserListCreateModal from "../Modal/UserListCreateModal";
// import actions from "../../../ReduxStore/actions/index";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   setHeaderName,
//   setSubHeaderName,
// } from "../../../ReduxStore/Slices/headerSlice";
// import { toast } from "react-toastify";
// import AddCountryModal from "../Modal/AddCountryModal";

// const AddCountry = () => {
//   const dispatch = useDispatch();

//   const { multiUserCreation } = useSelector(
//     (state) => state?.multiUserCreation
//   );

//   const { updateAuthUser } = useSelector(
//     (state) => state?.updateAuthUser
//   );


//   const tableHeadData = [
//     "S.No",
//     "County",
//     "States",
//     "City",
//     // "Mobile Number",
//     // "User Role",
//     // "Status",
//   ];

//   const { getAllUserWithRole } = useSelector(
//     (state) => state?.getAllUserWithRole
//   );

//   console.log(
//     getAllUserWithRole?.data,
//     "getAllCustomersStatusgetAllCustomersStatus"
//   );


//   const { softDeleteAuthUser } = useSelector(
//     (state) => state?.softDeleteAuthUser
//   );

//   useEffect(() => {
//     const fetchData = async () => {
//       const data1 = { data: {}, method: "get", apiName: `getAllCountriesWithDetails` };
//       await dispatch(actions.GETALLCOUNTRIESWITHDETAILS(data1));
//     };
//     fetchData();
//   }, [dispatch]);




//   const [rowTableData, setRowTableData] = useState([
//     {
//       name: "--",
//       operator_id: "--",
//       email: "--",
//       phone: "--",
//       userRole: "--",
//       Status: "--",
//     },
//   ]);

//   useEffect(() => {
//     const tempArr = [];
//     getAllUserWithRole?.data?.map((data, index) => {
//       return tempArr.push({
//         name: `${data?.name}`,
//         user_id: data?.user_id,
//         email: data?.email,
//         // phone: data?.phone,
//         // userRole: data?.userRole,
//         // Status: data?.delete_status === 0 ? "Active" : "Inactive",
//       });
//     });
//     setRowTableData(tempArr);
//   }, [dispatch, getAllUserWithRole, multiUserCreation, updateAuthUser]);



//   const handleTableDataDelete = async(id) => {


//     const data1 = {
//       data: {},
//       method: "delete",
//       apiName: `softDeleteAuthUser/${id}`,
//     };
//     const responseData = await dispatch(actions.SOFTDELETEAUTHUSER(data1));
//     if (responseData?.payload?.message === "User deleted successfully (soft delete).") {
//       toast.success("User soft delete sucessfully!")
//     } else {
//       toast.error(responseData?.payload?.message)

//     }
//     }




//     const customerId = useSelector((state) => state.customer.customerId);
//     const TableId = useSelector((state) => state.Table.TableId);


//     console.log(customerId, "customerIddd")
//     React.useEffect(() => {
//       dispatch(setHeaderName("Master"));
//       dispatch(setSubHeaderName("Add Country"));
//     }, [dispatch]);

//     return (
//       <Grid container spacing={2}>
//         <Grid item xs={12} sx={{ width: "100px" }}>
//           <CustomTable
//             tableData={rowTableData}
//             title="User List"
//             tableHeadData={tableHeadData}
//             modalName={AddCountryModal}
//             editModalName={AllUserListCreateModal}
//             modalHeadingName="Create User"
//             tableEdit="tableEdit"
//             tableDelete="tableDelete"
//             dataCreate={true}
//             handleTableDataDelete={handleTableDataDelete}
//           />
//         </Grid>
//       </Grid>
//     );
//   };

//   export default AddCountry;


import React, { useEffect, useState } from "react";
import CustomTable from "../../../Components/Table/CustomTable";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import actions from "../../../ReduxStore/actions/index";
import { setHeaderName, setSubHeaderName } from "../../../ReduxStore/Slices/headerSlice";
import AddCountryModal from "../Modal/AddCountryModal";
import CountryViewModal from "../Modal/CountryViewModal";

const AddCountry = () => {
  const dispatch = useDispatch();

  const { getAllCountriesWithDetails } = useSelector((state) => state?.getAllCountriesWithDetails);

  const tableHeadData = ["S.No", "Country", "States", "Cities", "KYCs"];

  const { AddCountryPost } = useSelector(
    (state) => state?.AddCountryPost
  );

  const { AddCityPost } = useSelector(
    (state) => state?.AddCityPost
  );

  const { AddStatePost } = useSelector(
    (state) => state?.AddStatePost
  );
  const { addMultipleKYCs } = useSelector(
    (state) => state?.addMultipleKYCs
  );



  useEffect(() => {
    const fetchData = async () => {
      const data1 = { data: {}, method: "get", apiName: `getAllCountriesWithDetails` };
      await dispatch(actions.GETALLCOUNTRIESWITHDETAILS(data1));
    };
    fetchData();
  }, [dispatch, AddCountryPost, AddStatePost, AddCityPost,addMultipleKYCs]);

  const [rowTableData, setRowTableData] = useState([]);

  useEffect(() => {
    if (getAllCountriesWithDetails?.data) {
      const tempArr = getAllCountriesWithDetails.data.map((country, index) => ({
        id: index + 1,
        country_id: country?.country_id,
        country: country.country_name,
        states: country.states.length
          ? country.states.map((state) => state.state_name).join(", ")
          : "N/A",
        cities: country.states.length
          ? country.states.flatMap((state) => state.cities.map((city) => city.city_name)).join(", ")
          : "N/A",
        kycs: country.kycs.length ? country.kycs.map((kyc) => kyc.kyc_name).join(", ") : "N/A",
      }));
      setRowTableData(tempArr);
    }
  }, [getAllCountriesWithDetails]);

  const handleTableDataDelete = async (id) => {
    const data1 = { data: {}, method: "delete", apiName: `softDeleteAuthUser/${id}` };
    const responseData = await dispatch(actions.SOFTDELETEAUTHUSER(data1));
    responseData?.payload?.message === "User deleted successfully (soft delete)."
      ? toast.success("User soft deleted successfully!")
      : toast.error(responseData?.payload?.message);
  };

  useEffect(() => {
    dispatch(setHeaderName("Master"));
    dispatch(setSubHeaderName("Add Country"));
  }, [dispatch]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={rowTableData}
          title="Country List"
          tableHeadData={tableHeadData}
          modalName={AddCountryModal}
          modalHeadingName="Create Country"
          tableView={true}
          modalVeiwName={CountryViewModal}

          dataCreate={true}
          handleTableDataDelete={handleTableDataDelete}
        />
      </Grid>
    </Grid>
  );
};

export default AddCountry;
